import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import styles from './styles.module.less';

const propTypes = {
  QRCodeUrl: PropTypes.string.isRequired,
  fgColor: PropTypes.string,
  logWidth: PropTypes.number,
  logo: PropTypes.string,
};

const defaultProps = {
  fgColor: '#000',
  logWidth: 25,
  logo: '',
};

/**
 * 二维码组件
 */
class QRCodeComponent extends Component {
  QRCodeBox = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      QRCodeImageUrl: null,
    };
  }

  componentDidMount() {
    this.changeImage();
  }

  changeImage = () => {
    const { logWidth, logo } = this.props;
    const contentWidth = this.QRCodeBox.current.offsetWidth * 2;
    const contentHeight = this.QRCodeBox.current.offsetWidth * 2;

    const canvasDom = document.createElement('canvas');
    canvasDom.width = contentWidth;
    canvasDom.height = contentHeight;
    const context = canvasDom.getContext('2d');

    const canvas = document.getElementById('canvas');
    const codeImage = new Image();
    codeImage.src = canvas.toDataURL('image/png');

    codeImage.onload = () => {
      context.drawImage(codeImage, 0, 0, contentWidth, contentHeight);
      if (!logo) {
        const QRCodeImageUrl = canvasDom.toDataURL('image/png');
        this.setState({ QRCodeImageUrl });
        return;
      }

      const centerPoint = contentWidth / 2 - logWidth;
      const images = new Image();
      images.src = logo;
      images.onload = () => {
        context.drawImage(images, centerPoint, centerPoint, logWidth * 2, logWidth * 2);
        const QRCodeImageUrl = canvasDom.toDataURL('image/png');
        this.setState({ QRCodeImageUrl });
      };
    };
  };

  render() {
    const { QRCodeUrl, fgColor } = this.props;
    const { QRCodeImageUrl } = this.state;

    return (
      <div className={styles.contentBox} ref={this.QRCodeBox}>
        {
          QRCodeImageUrl
            ? <img src={QRCodeImageUrl} className={styles.imageChangeAfter} alt="" />
            : (
              <div className={styles.QRCodeContent}>
                <QRCode level="H" id="canvas" value={QRCodeUrl} fgColor={fgColor} />
              </div>
            )
        }
      </div>
    );
  }
}

QRCodeComponent.propTypes = propTypes;
QRCodeComponent.defaultProps = defaultProps;

export default QRCodeComponent;
